<div class="root-body root-body-sidebar-slim"
     [ngClass]="{
    'root-body-sidebar-slim': configService.config.menuMode === 'sidebar' || configService.config.menuMode === 'slim',
    'root-body-sidebar-static': configService.config.menuMode === 'sidebar' && configService.config.sidebarStatic,
    'root-body-horizontal': configService.config.menuMode === 'horizontal'}">
    <div class="header-controls mb-3" [formGroup]="range">
        <mat-form-field>
            <mat-label>Date Range</mat-label>
            <mat-date-range-input [rangePicker]="picker">
                <input matStartDate formControlName="start" (dateChange)="onDateRangeChange()" placeholder="Start date">
                <input matEndDate formControlName="end"  (dateChange)="onDateRangeChange()" placeholder="End date">
            </mat-date-range-input>
            <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-date-range-picker #picker></mat-date-range-picker>
        </mat-form-field>
        
		<button
			[matMenuTriggerFor]="exportFileType"
			mat-flat-button
			color="primary"
		>
			Export
			<mat-icon matSuffix>download</mat-icon>
		</button>

        <mat-menu #exportFileType="matMenu">
            <button mat-menu-item (click)="exportSettlementReport(fileTypeOptions.Excel)">XLSX</button>
            <button mat-menu-item (click)="exportSettlementReport(fileTypeOptions.CSV)">CSV</button>
            <button mat-menu-item (click)="exportSettlementReport(fileTypeOptions.PDF)">PDF</button>
        </mat-menu>
    </div>
    <div class="mat-elevation-z8">
                <div *ngIf="loading" class="loading-container">
                    <mat-spinner></mat-spinner>
                    <p>Loading finance reports...</p>
                </div>

                <div *ngIf="!loading && isEmpty" class="empty-state-container">
                    <div class="empty-state-content">
                        <mat-icon class="empty-state-icon">receipt_long</mat-icon>
                        <h3 class="empty-state-title">No Finance Settlement Reports Found</h3>
                        <p class="empty-state-description">
                            No finance Settlement reports are available for the selected date range. 
                            Try adjusting your date filter or check back later.
                        </p>
                    </div>
                </div>

        <table 
            mat-table 
            [dataSource]="dataSource"
            matSort
            (matSortChange)="onSortChange($event)"
		    *ngIf="!loading && !isEmpty"
		    [matSortDirection]="currentSortDirection">
    
        <ng-container matColumnDef="storeName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Store Name</th>
            <td mat-cell *matCellDef="let element">{{element.storeName}}</td>
        </ng-container>
    
        <ng-container matColumnDef="transactionDate">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Transaction Date</th>
            <td mat-cell *matCellDef="let element">{{element.transactionDate}}</td>
        </ng-container>
    
        <ng-container matColumnDef="transactionTime">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Transaction Time</th>
            <td mat-cell *matCellDef="let element">{{element.transactionTime}}</td>
        </ng-container>
    
        <ng-container matColumnDef="transactionType">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Transaction Type</th>
            <td mat-cell *matCellDef="let element">{{element.transactionType}}</td>
        </ng-container>
    
        <ng-container matColumnDef="transactionAmount">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Transaction Amount</th>
            <td mat-cell *matCellDef="let element">₱{{element.transactionAmount | number:'1.2-2'}}</td>
        </ng-container>
    
        <ng-container matColumnDef="promotions">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Promotions</th>
            <td mat-cell *matCellDef="let element">₱{{element.promotions | number:'1.2-2'}}</td>
        </ng-container>
    
        <ng-container matColumnDef="netCollected">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Net Collected</th>
            <td mat-cell *matCellDef="let element">₱{{element.netCollected | number:'1.2-2'}}</td>
        </ng-container>
    
        <ng-container matColumnDef="mdrFeeAmount">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>MDR/Fee Amount</th>
            <td mat-cell *matCellDef="let element">₱{{element.mdrFeeAmount | number:'1.2-2'}}</td>
        </ng-container>
    
        <ng-container matColumnDef="vatAmount">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Vat Amount</th>
            <td mat-cell *matCellDef="let element">₱{{element.vatAmount | number:'1.2-2'}}</td>
        </ng-container>
    
        <ng-container matColumnDef="netCashable">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Net Cashable</th>
            <td mat-cell *matCellDef="let element">₱{{element.netCashable | number:'1.2-2'}}</td>
        </ng-container>
    
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    
        </table>

        <mat-paginator 
            [length]="totalRecords"
            [pageSize]="pageSize"
            [pageIndex]="pageIndex"
            [pageSizeOptions]="pageSizeOptions"
            (page)="onPageChange($event)"
            showFirstLastButtons 
            *ngIf="!loading && !isEmpty">
        </mat-paginator>
    </div>
</div>


